import { useTheme } from "@emotion/react";
import { Box, Grid, Icon, Typography } from "@mui/material";

export default function SubheaderTitle({ title }) {
  const theme = useTheme();
  const styles = {
    title: {
      display: "flex",
      alignItems: "center",
      gap: 1,
      color: theme.palette.secondary.main,
      fontFamily: "Inter-Regular",
      fontSize: "1.1rem",
    },
    icon: {
      fontSize: "1.5rem",
      color: theme.palette.primary.main,
    },
  };

  return (
    <Grid item xs={12}>
      <Grid container spacing={0}>
        <Grid
          item
          xs={12}
          style={{
            display: "flex",
            alignContent: "center",
            padding: "10px 0 20px 0",
          }}
        >
          <Box
            sx={styles.title}
            style={{ display: "flex", alignContent: "center" }}
          >
            <Typography sx={styles.title} variant="h5">
              {title}
            </Typography>
          </Box>
        </Grid>
      </Grid>
    </Grid>
  );
}
